import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const countryApiUrl = `${baseApiUrl}/api/Country`;

export async function getCountries(orderBy) {
  return await httpRequest(fetchCountries.bind(this, orderBy));
}

async function fetchCountries(orderBy) {
  let config = getHttpHeaders();
    return await axios.get(`${countryApiUrl}?orderBy=${orderBy}`, config);
}

export async function addCountry(newCountry) {
  return await httpRequest(postCountry.bind(this, newCountry));
}

async function postCountry(newCountry) {
  let config = getHttpHeaders();
  return await axios.post(`${countryApiUrl}`, newCountry, config);
}

export async function updateCountry(id, updatedCountry) {
  return await httpRequest(putCountry.bind(this, updatedCountry, id));
}

async function putCountry(updatedCountry, id) {
  let config = getHttpHeaders();
  return await axios.put(`${countryApiUrl}`, { ...updatedCountry, id }, config);
}
